<template>
	<div>
        <h3>ChatGPT - modèles</h3>

		<b-button v-if="service == 'chatgpt' && _canGenerateIa" @click="get_list_models">Récupérer la liste des modèles</b-button>

		<p>Choisir un service
			<b-select v-model="service" :options="['chatgpt', 'perplexity']"></b-select>
		</p>

		<p>Choisir un modèle
			<span v-if='service == "chatgpt"'>
				<b-input v-model="model" :list="'list' + id"></b-input>
				<datalist :id="'list' + id">
					<option v-for="(option, idx) in models" :key="'c' + idx"  :value="option.value">{{ option.text }}</option>
				</datalist>
			</span>
			<span v-else>
				<b-input v-model="model" :list="'list' + id"></b-input>
				<datalist :id="'list' + id">
					<option v-for="(option, idx) in list_models" :key="'c' + idx">{{ option }}</option>
				</datalist>
			</span>
		</p>

		<div v-show="spinner" class="center_spinner">
			<fade-loader></fade-loader>
		</div>

		<div v-show="service == 'chatgpt'">

			<h3>Entrainement</h3>

			<p><b>Données initiales</b> - 10 lignes minimum</p>

			<b-select v-model="type_data_test" :options="[
				{value: 'tabulator', text: 'Tableau'},
				{value: 'database', text: 'Base de données'},
				{value: 'DatabaseRequestView', text: 'Base de données - multitables'},
			]" />

			<br /><br />

			<div v-if="type_data_test == 'tabulator'">
				<edit_tabulator @update="import_file" ref="tabulator"></edit_tabulator>
			</div>

			<DatabaseRequestView v-if="type_data_test == 'DatabaseRequestView'"
				@update="import_file"
				_type="db"
				:minimal="true"
				ref="tabulator" />

			<div v-if="type_data_test == 'database'">
				<database
					@update="import_file"
					:change_table="true"
					:name="false"
					:edit="false"
					ref="tabulator"></database>
			</div>

			<b>Options</b>

			<chatgpt_train 
				ref="editor"
				:data="test_data"
			></chatgpt_train>

			<b-button @click="train" :disabled="suffix.length > 18 || test_data.length < 10">Générer le modèle</b-button>

			<p v-if="generate">Le modèle est entrain de se générer, cela peut prendre plusieurs minutes à plusieurs heures. Une nouvelle version du modèle sera créé.</p>

			<div v-if="error">
				Erreur : {{ error }}
			</div>

			<br/><br />
		</div>

		<div v-show="spinner" class="center_spinner">
			<fade-loader></fade-loader>
		</div>
	</div>
</template>

<script>
	import uniqueId from "lodash.uniqueid";
	import workers from "../services/workers.js";
    import database from "../services/database.js";
	import projects from "../services/projects.js";
	import databaseView from "../views/database.vue";
	import treatments from "../services/treatments.js";
	import treatment from "../components/treatment.vue";
	import c_treatment_params from "../components/params.vue"
	import edit_tabulator from "../components/edit_tabulator.vue";
    import DatabaseRequestView from '../views/DatabaseRequestView.vue';

	var clone = require("clone");

	import moment from "moment";
	require('moment/locale/fr')

	import * as json2csv from "json2csv";
	import draggable from "vuedraggable";
	import FadeLoader from "vue-spinner/src/FadeLoader.vue";
	import chatgpt_train from "../components/steps/chatgpt_train.vue";
	import store from "../store";

	export default {
		name: "chatgpt_train_library",
		components: {
			edit_tabulator,
			database: databaseView,
			DatabaseRequestView,
			c_treatment_params,
			FadeLoader,
			draggable,
			chatgpt_train
		},
		props: {
		},
		data() {
			return {
                id: uniqueId(""),

				type_data_test: "tabulator",
				spinner: false,
				test_data: [],

				error: "",

				column_system: "",
				column_user: "",
				column_assistant: "",
				suffix: "",
				generate: false,
				train_model: "",

				models: [],
				model: "",
				service: "chatgpt",
				error: "",
				list_models: [],
				list: [],
				list_train_models: []
			};
		},
		watch: {
			service: {
                immediate: true,
                async handler()
                {
					this.list_models = [];
					if (this.service == "perplexity")
					{
						var list = this.list
						for (var i = 0; i < list.length; i++)
						{
							if (list[i].service == 'perplexity')
								this.list_models.push(list[i].model)
						}
					}
				}
			}
		},
		computed: {
			_canGenerateIa() {
				const rules = store.state.user ? store.state.user.rules : undefined;
				if (rules === null) return true;
				return !!(rules && rules.generate_ia);
			}
		},
		methods: {
			async get_list_models()
			{
				this.spinner = true;

				var formData = new FormData();
				formData.append("action", "saas_back-openai");
				formData.append("parameters", JSON.stringify({
					type: "list_models"
				}));

				var data = await workers.test(formData);

				var list = data.data.json[0].result.data;

				list.sort((a, b) => (a.created > b.created) ? -1 : 1)

				this.models = [{text: "", value: ""}];
				for (var i = 0; i < list.length; i++)
				{
					if (list[i].owned_by.startsWith("user") || 
						list[i].id.startsWith("gpt-3") || 
						list[i].id.startsWith("gpt-4") || 
						list[i].id.startsWith("gpt-5") || 
						list[i].id.startsWith("o") || 
						list[i].id.startsWith("ft:"))
					{
						this.models.push({
							text: list[i].id + " - " + moment(list[i].created * 1000).format("LLL"),
							value: list[i].id
						})
					}
				}

				this.spinner = false;
			},
			import_file()
			{
				console.log("import_file")
				this.test_data = this.$refs.tabulator.get_data();
			},
			async train()
			{
				console.log("train");

				this.error = "";
				this.spinner = true;
				this.error = ""

				this.test_data = await this.$refs.tabulator.get_data();
				var str_csv = json2csv.parse(this.test_data, {
					fields: Object.keys(this.test_data[0]),
					fieldNames: Object.keys(this.test_data[0]),
				});

				var files = [
					new File([str_csv], "data.csv", {
						type: "text/csv",
					}),
				];

				var formData = new FormData();
				formData.append(files[0].name, files[0]);
				formData.append("action", "chatgpt_train");
				formData.append("parameters", JSON.stringify(this.$refs.editor.save()));

				try
				{
					var data = await workers.test(formData);
				}
				catch (err)
				{
					this.error = err;
					this.spinner = false;				
					return;
				}

				this.generate = true;

				this.spinner = false;
				
			},
			async load(data)
			{
				var self = this;

				if (data.type_data_test)
					this.type_data_test = data.type_data_test;
				else
					this.type_data_test = "tabulator"

				if (data.params)
					this.$refs.editor.load(data.params);

				console.log(data.model)
				if (data.model)
				{
					this.models = [{
						text: data.model,
						value: data.model
					}]
					this.model = data.model;
				}

				if (data.train_file)
				{
					data.test_data = await treatments.getFileAlyx(
						data.train_file,
						false,
						false
					);

					data.test_data = this.$papa.parse(data.test_data, { header: true });
					data.test_data = data.test_data.data;
				}

                self.$nextTick(async function () {
					if (data.test_data)
					{
						self.$refs.tabulator.load(data.test_data);
					}
						
				});
			},
			async save()
			{
				var data = null;
				
				data = await this.$refs.tabulator.save();

				return {
					test_data: data,
					suffix: this.suffix,
					model: this.model,
					service: this.service,
					train_model: this.train_model,
					params: this.$refs.editor.save(),
					data_db: {
						suffix: this.suffix,
						model: this.model,
						service: this.service,
						train_model: this.train_model,
						params: this.$refs.editor.save()
					}

				}
			},
		},
		mounted: async function () {

			this.list = await workers.gpt_list_cost();
			this.list_train_models = [];
			for (var i = 0; i < this.list.length; i++)
			{
				if (this.list[i].fine_tuning)
					this.list_train_models.push(this.list[i].model);
			}
			this.train_model = this.list_train_models.length > 0 ? this.list_train_models[0] : "";
		},
	};
</script>

<style>
.center_spinner {
	width: 0%;
	margin: 0 auto;
	margin-top: 30px;
}
</style>
